import React, { useState } from 'react';
 import SEO from "../components/seo";

const Contact = () => {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    number: "",
    email: "",
    service_type: "",
    message: "",
    save_info: false,
  });

  const [responseMsg, setResponseMsg] = useState(""); // message display ke liye
  const [loading, setLoading] = useState(false);     // loading state

  // Input change handle
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
    setResponseMsg(""); // Clear previous response message
  };

  // Submit API
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMsg("");

    setLoading(true);
    setResponseMsg("");

    // Phone number validation
    if (!formData.number || formData.number.length !== 10) {
      setResponseMsg("Phone number must be exactly 10 digits.");
      setLoading(false);
      return;
    }

    try {
      // Convert checkbox boolean to 0/1 for PHP
      const payload = { ...formData, save_info: formData.save_info ? 1 : 0 };

      const res = await fetch("https://karmyogienterprise.com/contact_api/insert_contact.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });

      const result = await res.json();

      setResponseMsg(result.message);

      // Reset form if successful
      if (result.status === "success") {
        setFormData({
          first_name: "",
          // last_name: "",
          email: "",
          number: "",
          service_type: "",
          message: "",
          save_info: false,
        });
      }
    } catch (error) {
      setResponseMsg("API Error: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
     <SEO page="contact" />
    <main>
      {/* breadcrumb area */}
      <section className="ca-breadcrumb-area cream-bg-3 p-relative z-index-1 fix">
        <div className="ca-breadcrumb-shape p-absolute bre-sh-1">
          <img src="/static/img/shape/breadcrumn-shape.webp" alt="" />
        </div>
        <div className="ca-breadcrumb-shape p-absolute bre-sh-2">
          <img src="/static/img/shape/ca-line-shape.webp" alt="" />
        </div>
        <div className="container">
          <div className="ca-breadcrumb-content text-center">
            <h2 className="ca-breadcrumb-title fnw-600">Contact Us</h2>
            <div className="it-breadcum-link">
              <a href="/">Home</a>
              <span><i className="fa-solid fa-angle-right" /></span>
              <a className="active" href="#">Contact Us</a>
            </div>
          </div>
        </div>
      </section>

      {/* contact info */}
      <section className="ca-contact-inner pt-100 pb-70">
        <div className="container">
          <div className="row">
            {/* Address */}
            <div className="col-xl-4 col-md-6 mb-30 col-xl-4-1 col-md-6-1 mb-30-1">
              <div className="ca-location-3 ca-location-3-1">
                <div className="ca-location-icbox ca-location-icbox-1">
                  <div className="ca-location-icbox-img">
                    <span><img src="/static/img/icon/ca-map3.1.svg" alt="" /></span>
                  </div>
                  <div className="ca-location-icbox-text">
                    <h4 className="ca-title fnw-600 theme-black-3 pb-16">Our Address</h4>
                    <p>91 Shubham Industrial Estate <br />Puna-Valthan Road, Surat</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Phone */}
            <div className="col-xl-4 col-md-6 mb-30 col-xl-4-1 col-md-6-1 mb-30-1">
              <div className="ca-location-3 ca-location-3-1">
                <div className="ca-location-icbox ca-location-icbox-1">
                  <div className="ca-location-icbox-img">
                    <span><img src="/static/img/icon/ca-ph3.2.svg" alt="" /></span>
                  </div>
                  <div className="ca-location-icbox-text">
                    <h4 className="ca-title fnw-600 theme-black-3 pb-16">Contact Us</h4>
                    <a href="tel:+91 6352 099 433">+91 6352 099 433</a> <br />
                    {/* <a href="tel:+47122109878">(+47) 1221 09 878</a> */}
                  </div>
                </div>
              </div>
            </div>

            {/* Email */}
            <div className="col-xl-4 col-md-6 mb-30 col-xl-4-1 col-md-6-1 mb-30-1">
              <div className="ca-location-3 ca-location-3-1">
                <div className="ca-location-icbox ca-location-icbox-1">
                  <div className="ca-location-icbox-img">
                    <span><img src="/static/img/icon/ca-envelop3.3.svg" alt="" /></span>
                  </div>
                  <div className="ca-location-icbox-text">
                    <h4 className="ca-title fnw-600 theme-black-3 pb-16">Email Us</h4>
                    <a href="mailto:tarak@karmyogienterprise.com">tarak@karmyogienterprise.com</a>
                    <br />
                    {/* <a href="mailto:drmtech99.com">drmtech99.com</a> */}
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* map */}
      <div className="ca-maps">
        <iframe
          // src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13879239.529449532!2d43.044947896897405!3d31.866193584077507!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ef7ec2ec16b1df1%3A0x40b095d39e51face!2sIran!5e0!3m2!1sen!2sbd!4v1723948083378!5m2!1sen!2sbd"
          src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d59518.86565638685!2d72.8962549!3d21.194975149999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1s91%20Shubham%20Industrial%20Estate%2C%20Puna-Valthan%20Road%2C%20Surat!5e0!3m2!1sen!2sin!4v1763526205304!5m2!1sen!2sin"
          className="contact-page__google-map"
          allowFullScreen
          title="Google Map"
        />
      </div>

      {/* contact form */}
      <section className="ca-conatct-form1 pb-100">
        <div className="container">
          <div className="row">
            <div className="ca-con-rep-form cream-bg-3 text-center">
              <h4 className="ca-title fnw-600 theme-black-3 pb-16">Send Us Message</h4>
              <p className="pb-32">Your email address will not be published. Required fields are marked *</p>

              <div className="ca-cmt-from">
                <form onSubmit={handleSubmit}>
                  <div className="row">

                    <div className="col-lg-6 mb-20">
                      <input type="text" name="first_name" placeholder="First Name" value={formData.first_name} onChange={handleChange} required />
                    </div>

                    {/* <div className="col-lg-6 mb-20">
                      <input type="text" name="last_name" placeholder="Last Name" value={formData.last_name} onChange={handleChange} required />
                    </div> */}

                    <div className="col-lg-6 mb-20">
                      {/* <input type="tel" name="number" placeholder="phone Number" value={formData.number} 
                      // onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')} 
                      onInput={(e) => {
                          // Remove non-numeric characters
                          e.target.value = e.target.value.replace(/[^0-9]/g, "");
                          // Limit to 10 digits
                          if (e.target.value.length > 10) {
                            e.target.value = e.target.value.slice(0, 10);
                          }
                        }}
                      onChange={handleChange} required /> */}
                      <input
                        type="tel"
                        name="number"
                        placeholder="Phone Number"
                        value={formData.number}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/[^0-9]/g, "").slice(0, 10);
                          handleChange(e); // state update ensure
                        }}
                        required
                      />


                    </div>

                    <div className="col-lg-6 mb-20">
                      <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
                    </div>

                    {/* <div className="col-lg-6 mb-20">
                      <input type="tel" name="number" placeholder="phone Number" value={formData.number} onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')} onChange={handleChange} required />
                    </div> */}

                    <div className="col-lg-6 mb-20">
                      <select name="service_type" className="ca-select" value={formData.service_type} onChange={handleChange} required>
                        <option value="">Select Service</option>
                        <option value="U Bend">U Bend</option>
                        <option value="C Bend">C Bend</option>
                        <option value="Y Bend">Y Bend</option>
                        <option value="Copper Filter">Copper Filter</option>
                        <option value="Copper Tripod">Copper Tripod</option>
                        <option value="Copper Tee">Copper Tee</option>
                        <option value="Copper Elbow">Copper Elbow</option>
                        <option value="Copper Cap">Copper Cap</option>
                        <option value="Copper Straight Pipe">Copper Straight Pipe</option>
                        <option value="Copper Pancake">Copper Pancake</option>
                        <option value="Copper Tube LWC">Copper Tube LWC</option>
                        <option value="Alluminum For Fins">Alluminum For Fins</option>
                        <option value="Copper Foil">Copper Foil</option>
                        <option value="Brazzing Road">Brazzing Road</option>
                        <option value="NRV Valves">NRV Valves</option>
                        <option value="Distributors">Distributors</option>
                      </select>
                    </div>

                    <div className="col-lg-12 mb-20">
                      <textarea name="message" placeholder="Message" value={formData.message} onChange={handleChange} required />
                    </div>

                  </div>

                  <div className="ca-radion-btn">
                    <input type="checkbox" id="saveinfo" name="save_info" checked={formData.save_info} onChange={handleChange} />
                    <label htmlFor="saveinfo">Save information in browser</label>
                  </div>

                  <div className="ca-blg-sen-btn text-start">
                    <button type="submit" className="ca-btn-primary-3 theme-bg-3 text-white br-50" disabled={loading}>
                      {loading ? "Submitting..." : "Submit Now"} <span><i className="fa-solid fa-angle-right" /></span>
                    </button>
                  </div>

                  {/* {responseMsg && <p className="pt-3">{responseMsg}</p>} */}
                  {responseMsg && (
                    <p
                      className={`pt-3 ${responseMsg.includes("Thank you")
                          ? "text-success"
                          : "text-danger"
                        }`}
                    >
                      {responseMsg}
                    </p>
                  )}


                </form>
              </div>

            </div>
          </div>
        </div>
      </section>
    </main>
    </>
    
  );
};

export default Contact;
